import React from 'react';

require('./smartImage.scss');

export default class SmartImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lowResHidden: true,
      highResHidden: true,
    };
  }

  handleImageLoad(event) {
    this.setState({ [event.target.name]: false });
  }

  render() {
    const { imageName } = this.props;
    return (
      <div className={this.props.className ? `progressive-image-loading ${this.props.className}` : 'progressive-image-loading'}>
        <picture>
          <source media="(min-width: 768px)" srcSet={`${this.props.slug}load/desktop/${imageName}`} />
          <source srcSet={`${this.props.slug}load/mobile/${imageName}`} />
          <img
            className={this.state.lowResHidden && !this.state.highResHidden ? 'img-low-res hide' : 'img-low-res show'}
            name="lowResHidden"
            src={`${this.props.slug}load/mobile/${imageName}`}
            onLoad={event => this.handleImageLoad(event)}
            alt="SmartImage"
          />
        </picture>
        {this.state.lowResHidden ?
          (
            <span />
          )
          :
          (
            <picture>
              <source media="(min-width: 1680px)" srcSet={`${this.props.slug}2160/${imageName}`} />
              <source media="(min-width: 768px)" srcSet={`${this.props.slug}1680/${imageName}`} />
              <source srcSet={`${this.props.slug}mobile/${imageName}`} />
              <img
                className={this.state.highResHidden ? 'img-high-res hide' : 'img-high-res show'}
                name="highResHidden"
                src={`${this.props.slug}mobile/${imageName}`}
                onLoad={event => this.handleImageLoad(event)}
                alt="SmartImage"
              />
            </picture>
          )
        }
      </div>
    );
  }
}
